// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Moi {{first_name}}, mitä tarvitset ravintolalle {{restaurant}}?',
  title_no_name: 'Hei, mitä tarvitset ravintolalle {{restaurant}}?',
  text: 'Voin vastata kysymyksiin ravintolasta {{restaurant}} ja tehdä muutoksia puolestasi. Mikään ei muutu ennen kuin hyväksyt sen.',
  suggestions: 'Ehdotukset',
  prompts: {
    reports: {
      top_dishes: 'Mitkä olivat viime kuun 10 myydyintä annosta?',
      sales_vs_last_month: 'Miten myynti kehittyi viime kuuhun verrattuna?',
    },
    menu: {
      raise_dish_price: 'Nosta annoksen {{dish}} hintaa {{amount}}',
      dish_sold_out: 'Merkitse {{dish}} loppuunmyydyksi',
      dishes_without_photo: 'Mistä annoksista puuttuu kuva?',
    },
    hours: {
      holiday_hours: 'Muuta aukioloaikojamme 24. joulukuuta',
    },
    order_settings: {
      minimum_order: 'Nosta vähimmäistilausta tasolle {{amount}}',
    },
    marketing: {
      promo_code: 'Luo 10 %:n alennuskoodi tälle viikonlopulle',
    },
    my_info: {
      phone_number: 'Päivitä puhelinnumeromme',
    },
  },
};
